export default __webpack_public_path__ + "static/media/forbidden-panel.11439413.svg";